








































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import { Route } from 'vue-router'
import { AppModule } from '@/store/modules/app'
import { PermissionModule } from '@/store/modules/permission'
import SidebarItem from './SidebarItem.vue'
// import variables from '@/styles/_variables.scss'

@Component({
  name: 'SideBar',
  components: {
    SidebarItem
  }
})
export default class extends Vue {
  get sidebar() {
    console.info(PermissionModule.routers)
    return PermissionModule.routers
  }

  get routes() {
    return (this.$router as any).options.routes
  }
  // get variables() {
  //   return variables
  // }
  //
  // get isCollapse() {
  //   return !this.sidebar.opened
  // }
  @Watch('$route', { immediate: true })
  private onRouteChange(route: Route) {
    // 展开当前路由
    let mainPath = route.matched[0].path
    let subPath = route.matched[1].path
    let sidebar = this.sidebar.map(item => {
      if (item.path === mainPath) {
        item.children.map((_item:any) => {
          if (item.path + '/' + _item.path === subPath) {
            _item.meta.drop = true
          }
        })
      }
      return item
    })
    PermissionModule.SetRouters(sidebar)
  }
}
